module.exports = __webpack_public_path__ + "static/img/Mobile.48630535.svg";